import React, { useContext, useState, useEffect } from 'react';
import LabeledInput from '../common/LabeledInput.jsx';
import requests from '../utils/requests.js';
import { PersonContext } from '../providers/Person.jsx';
import AutocompleteAny from '../common/AutocompleteAny.jsx';
import { s } from '../Style.jsx';

const Drivers = () => {

    const [driver, setDriver] = useState(false);
    const [editingDriverId, editDriverId] = useState(false);

    const { auth, newNotifications, silentNotifications } = useContext(PersonContext);

    const [people, setPeople] = useState([]);
    useEffect(() => { requests.getPeople(auth).then(people => setPeople(people)) }, []);

    const [drivers, setDrivers] = useState([]);
    const [gettingDrivers, setGettingDrivers] = useState(true);
    useEffect(() => { requests.getDrivers(auth, setGettingDrivers).then(drivers => setDrivers(drivers)) }, [newNotifications]);
    useEffect(() => { requests.getDrivers(auth).then(drivers => setDrivers(drivers)) }, [silentNotifications]);

    const [savingDriver, setSavingDriver] = useState(false);
    const saveDriver = async () => {
        setSavingDriver(true);
        await requests.updateDriver(auth, {
            name: driver.name,
            uid: driver.uid,
            pin: driver.pin,
        }, editingDriverId);
        requests.getDrivers(auth).then(drivers => {
            setSavingDriver(false);
            setDrivers(drivers);
        });
    };

    const [addingDriver, setAddingDriver] = useState(false);
    const newDriver = async () => {
        setAddingDriver(true);
        await requests.addDriver(auth);
        requests.getDrivers(auth).then(Drivers => {
            setDrivers(Drivers);
            setAddingDriver(false);
        });
    };

    const [deletePrompt, setDeletePrompt] = useState(false);
    const [deletingDriver, setDeletingDriver] = useState(false);
    const deleteConfirm = async () => {
        setDeletingDriver(true);
        setDeletePrompt(false);
        setDriver(false);
        editDriverId(false);
        await requests.deleteDriver(auth, editingDriverId);
        requests.getDrivers(auth).then(Drivers => {
            setDrivers(Drivers);
            setDeletingDriver(false);
        });
    };

    const [hourlyEarnings, setHourlyEarnings] = useState({});
    useEffect(() => {
        //clear hourly earnings when drivers change
        if (drivers && drivers.length) {
            const newHourlyEarnings = {};
            drivers.forEach(driver => {
                newHourlyEarnings[driver.id] = driver.hourlyEarnings || 0;
            });
            setHourlyEarnings(newHourlyEarnings);
        } else {
            setHourlyEarnings({});
        }
    }, [drivers]);

    return <div style={s.mobileContainer}>

        {(!drivers || !drivers.length || addingDriver || savingDriver || deletingDriver) && <p><i className="fas fa-spinner fa-spin"></i></p>}

        {drivers && !!drivers.length && !addingDriver && !savingDriver && <>

            {!editingDriverId && <button style={s.button} onClick={newDriver}>Add Driver</button>}

            {(gettingDrivers) && <p><i className="fas fa-spinner fa-spin"></i></p>}

            {!gettingDrivers && !!drivers.length && <div style={{ ...s.box, paddingBottom: 0 }}>
                <table style={s.table}>
                    {(!!editingDriverId ? [drivers.find(o => o.id == editingDriverId)] : drivers).map((driver, v) => <tr key={driver.id} style={s.cell(v)}>

                        <td style={{}}><s.IconButton icon="fas fa-edit" does={() => {
                            setDeletePrompt(false);
                            setDriver(driver);
                            editDriverId(editingDriverId === driver.id ? false : driver.id);
                        }} /></td>

                        {!driver.reportId && <td style={{ maxWidth: 200, minWidth: 200 }}><s.IconButton does={async () => {
                            setGettingDrivers(true);
                            await requests.updateDriver(auth, { reportId: true }, driver.id);
                            requests.getDrivers(auth, setGettingDrivers).then(drivers => setDrivers(drivers));
                        }} icon="fas fa-sign-in-alt" /></td>}

                        {driver.reportId && <td style={{ maxWidth: 200, minWidth: 200, ...s.rowCenter }}>
                            <s.IconButton color="green" textColor="white" does={async () => {
                                setGettingDrivers(true);
                                await requests.updateDriver(auth, { reportId: false, earnings: hourlyEarnings[driver.id] || driver.hourlyEarnings || 0 }, driver.id);
                                requests.getDrivers(auth, setGettingDrivers).then(drivers => setDrivers(drivers));
                            }} icon="fas fa-sign-out-alt" />
                            <span style={{ fontSize: 12, flex: 1 }}>Reporting ID: {driver.reportId}</span>
                        </td>}

                        <td style={{ ...s.tableCell }}>{driver.name}</td>

                        <td style={{ ...s.tableCell }}>
                            <LabeledInput
                                prefix='$'
                                iw={160}
                                boxstyle={{ width: 170, marginRight: 4 }}
                                value={hourlyEarnings[driver.id] || driver.hourlyEarnings || ""}
                                onChange={value => {
                                    setHourlyEarnings({ ...hourlyEarnings, [driver.id]: value });
                                }}
                                type="number" />
                        </td>

                    </tr>)}
                </table>
            </div>}

            {editingDriverId && <>
                {deletingDriver || savingDriver && <p><i className="fas fa-spinner fa-spin"></i></p>}
                {!deletingDriver && !savingDriver && <>

                    <h3 style={{ marginBottom: 10 }}><s.BackArrow does={() => {
                        setDeletePrompt(false);
                        editDriverId(false);
                        setDriver(false);
                    }
                    }
                    /> Driver Details</h3>
                    <div style={s.box}>
                        <div style={s.table}>
                            <div style={s.cell(0)}>
                                <label style={{ flex: 1 }}>Name</label>
                                <LabeledInput value={driver.name} onChange={value => setDriver({ ...driver, name: value })} />
                            </div>
                            <div style={s.cell(1)}>
                                <label style={{ flex: 1 }}>Phone Number</label>
                                <AutocompleteAny type="person" selected={driver.uid} options={people} onChange={(person) => setDriver({ ...driver, uid: person.id })} />
                            </div>
                            <div style={s.cell(0)}>
                                <label style={{ flex: 1 }}>Pin</label>
                                <LabeledInput value={driver.pin} onChange={value => setDriver({ ...driver, pin: value })} />
                            </div>
                        </div>
                        <button onClick={saveDriver}>Save</button>
                    </div>

                    <span style={{ fontSize: 14, textAlign: "right", display: "block", marginTop: 20 }}>
                        {deletePrompt
                            ? <>
                                <button style={{ marginLeft: 4 }} onClick={deleteConfirm}>Yes</button>
                                <button style={{ marginLeft: 4 }} onClick={() => setDeletePrompt(false)}>No</button>
                                <span style={{ fontSize: 12 }}>Are you sure you want to delete this driver?</span>
                            </>
                            : <>
                                <button style={{ marginLeft: 4 }} onClick={() => setDeletePrompt(true)}>Delete Driver</button>
                            </>}
                    </span>
                </>}
            </>}

        </>}
    </div >;
}

export default Drivers;